import React from 'react'
export default function MinimalUpIcon({ size = 24, width = size, height = size, fill, secondaryFill, stroke, secondaryStroke, children }) {
  return (<svg width={width} height={height} xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 16 16">{children}
<g fill={fill} stroke={stroke} className="nc-icon-wrapper"><path d="M14.3 12.6 8 6.3l-6.3 6.3-1.4-1.5L8 3.4l7.7 7.7z"/></g></svg>)
}
